<template>
  <div class="performance-table-box">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="项目名称">
        <template slot-scope="props">
          <span @click="rowClick" style="color: #409EE9; cursor: pointer;">{{props.row.date}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="工程地点"></el-table-column>
      <el-table-column prop="address" label="业主/总包单位"></el-table-column>
      <el-table-column prop="address" label="开工/竣工"></el-table-column>
    </el-table>
    <el-dialog title="详细信息" class="box-detail" :visible.sync="dialogTableVisible">
      <div class="box-detail-inner">
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>项目名称：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.projectName}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>开工/竣工：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.timeCompletion}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>工程地点：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.address}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>业主：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.owner}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>总包单位：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.contractor}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>证明人：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.testifier}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>描述：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <span>{{boxDetail.describe}}</span>
          </el-col>
        </el-row>
        <el-row class="martop">
          <el-col :span="2" class="tit">
            <span>证明文件：</span>
          </el-col>
          <el-col :span="22" class="cont">
            <ul class="img-list" v-if="boxDetail.evidenceList">
              <li v-for="(item, index) in boxDetail.evidenceList" :key="index">
                <img v-lazy="item" alt>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogTableVisible: false,
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      boxDetail: {
        address: '往往让他问而',
        contractor: '我而台湾儿童问题',
        describe: '我而台湾儿童玩儿',
        documentaryEvidence:
          'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215110985309657.jpg,https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215111279112112.gif,https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215111522515229.peg,https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215111748417535.bmp',
        evidenceList: [
          'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215110985309657.jpg',
          'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215111279112112.gif',
          'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215111522515229.peg',
          'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616215111748417535.bmp'
        ],
        id: 1529,
        owner: '问题',
        projectName: '我去二群翁',
        testifier: '儿童',
        timeCompletion: '2019-7-25~2019-7-29'
      }
    }
  },
  methods: {
    rowClick (rowData) {
      // this.boxDetail = rowData;
      this.dialogTableVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.performance-table-box {
  border: 1px solid #e4e7ed;
  border-bottom: none;
}
.box-detail{
  .box-detail-inner{
    width: 920px;
  }
  .martop{
    margin-bottom: 20px;
  }
  .tit{
    text-align: right;
    color: #666;
  }
  .cont{
    color: #333;
    .img-list{
      overflow: hidden;
      width: 440px;
      li{
        float: left;
        width: 200px;
        margin-right: 20px;
        margin-bottom: 20px;
        img{
          display: block;
          width: 200px;
          height: 120px;
          background-color: #ddd;
        }
      }
    }
  }
}
</style>
